import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  const navLinks = [
    { path: '/', label: t('common:navHome') },
    { path: '/category/action', label: t('common:navCategory') },
    { path: '/about', label: t('common:navAbout') },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0 group">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-2-line text-background-50 text-lg md:text-xl"></i>
            </div>
            <span className={`text-xl md:text-2xl font-heading font-bold transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-background-50'
            }`}>
              {t('common:siteName')}
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(link.path)
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-50/20 text-background-50'
                    : scrolled
                      ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/15'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <div className={`relative rounded-full px-4 py-2 text-sm transition-all duration-200 flex items-center gap-2 border ${
              scrolled
                ? 'border-background-200 bg-background-100 text-foreground-500'
                : 'border-background-50/30 bg-background-50/10 text-background-50/70'
            }`}>
              <i className="ri-search-line text-sm"></i>
              <span className="hidden lg:inline">{t('common:navSearch')}</span>
            </div>
          </div>

          <button className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer">
            <i className={`ri-menu-line text-xl ${
              scrolled ? 'text-foreground-900' : 'text-background-50'
            }`}></i>
          </button>
        </div>
      </div>
    </header>
  );
}